/*
 * Planigo
 * Auteur  : Stéphane Raverdy
 * Société : SCIAD 2026
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { Briefcase, Package, ClipboardText } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import AssetsPage from './AssetsPage';
import GmaoPage from './GmaoPage';

export default function AssetsStockHubPage({ initialView }) {
  const location=useLocation(); const navigate=useNavigate();
  const queryView=new URLSearchParams(location.search).get('view');
  const view=queryView || initialView || (location.pathname==='/store'?'store':'park');
  return <div className="space-y-4">
    <div className="rounded-2xl border bg-white p-3 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 shadow-sm">
      <div><div className="font-black text-slate-900">Parc & stocks</div><div className="text-xs text-slate-500">Une seule fiche Article (ART) pour le stock et les matériels physiques du Parc.</div></div>
      <div className="flex flex-wrap gap-2">
        <Button variant={view==='store'?'default':'outline'} onClick={()=>navigate('/assets?view=store')}><Package size={16} className="mr-1"/>Articles & stocks</Button>
        <Button variant={view==='park'?'default':'outline'} onClick={()=>navigate('/assets')}><Briefcase size={16} className="mr-1"/>Parc matériel</Button>
        <Button variant="outline" onClick={()=>navigate('/inventory')}><ClipboardText size={16} className="mr-1"/>Inventaires / contrôles</Button>
      </div>
    </div>
    {view==='store'?<GmaoPage mode="store"/>:<AssetsPage/>}
  </div>;
}
